import React, { useState, useEffect } from "react";
import { AuthWrapper } from "../AuthWrapper";
import backArrow from "../assets/back-button.png";
import { toast } from "react-toastify";
import { fetchApi } from "../utlis/axios";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-number-input";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "react-phone-number-input/style.css";

const RegisterIms = ({
  setShowModal,
  onSuccess,
  isEditMode = false,
  initialData = null,
  storeId = null,
  userId = null,
  onCancel,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [formValues, setFormValues] = useState({
    email: "",
    imsName: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    password: "",
    license_key: "",
    db_backup_url: "",
    extra_data: null,
  });

  useEffect(() => {
    if (isEditMode && initialData) {
      setFormValues((prev) => ({
        ...prev,
        imsName: initialData?.store_name ?? "",
        phoneNumber: initialData?.store_phone_number ?? "",
        address: initialData?.store_address ?? "",
        city: initialData?.store_city ?? "",
        state: initialData?.store_state ?? "",
        email: initialData?.email ?? initialData?.user?.email ?? "",
        license_key: initialData?.license_key ?? "",
        db_backup_url: initialData?.db_backup_url ?? "",  

      }));
    }
  }, [isEditMode, initialData]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!formValues?.imsName) {
      toast.error("Name is required");
      return;
    }
if(!formValues?.email) {
  toast.error("Email is required");
  return;
}
    try {
      setLoading(true);
     

      const storeFormData = new FormData();
      storeFormData.append("store_name", formValues?.imsName);
      storeFormData.append("store_phone_number", formValues?.phoneNumber);
      storeFormData.append("store_address", formValues?.address);
      storeFormData.append("store_city", formValues?.city);
      storeFormData.append("store_state", formValues?.state);
      storeFormData.append("license_key", formValues?.license_key);
      storeFormData.append("db_backup_url", formValues?.db_backup_url);
      storeFormData.append("email", formValues?.email);
      storeFormData.append("password", formValues?.password);
      storeFormData.append("is_active", true);

      await fetchApi.patch(`ims-auth/${storeId}`, storeFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });

      const mergedData = {
        ...initialData,
        store_name: formValues?.imsName,
        store_phone_number: formValues?.phoneNumber,
        store_address: formValues?.address,
        store_city: formValues?.city,
        store_state: formValues?.state,
        email: formValues?.email,
      };
      toast.success("Successfully Updated");
      onSuccess?.(mergedData);
      onCancel?.();
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.username?.[0] || error?.response?.data?.email?.[0] || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const PostRegistration = async (e) => {
    e.preventDefault();
    if (!formValues?.imsName) {
      toast.error("Name is required");
      return;
    }
    if(!formValues?.email) {
      toast.error("Email is required");
      return;
    }
    if(!formValues?.password) {
      toast.error("Password is required");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("store_name", formValues?.imsName);
      formData.append("store_phone_number", formValues?.phoneNumber);
      formData.append("store_address", formValues?.address);
      formData.append("store_city", formValues?.city);
      formData.append("store_state", formValues?.state);
      formData.append("license_key", formValues?.license_key);
      formData.append("db_backup_url", formValues?.db_backup_url);
      formData.append("email", formValues?.email);
      formData.append("password", formValues?.password);
      formData.append("is_active", true);

      const result = await fetchApi.post("ims-auth/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });

      if (result?.status === 201) {
        toast.success("Successfully Register");
        onSuccess?.(result?.data);
        setShowModal?.(false);
      }
      setFormValues({
        ...formValues,
        first_name: "",
        last_name: "",
        userName: "",
        email: "",
        imsName: "",
        phoneNumber: "",
        address: "",
        city: "",
        state: "",
      });
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.username?.[0]);
      toast.error(error?.response?.data?.email?.[0]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => (isEditMode ? handleUpdate(e) : PostRegistration(e));

  const handleGoBack = () => {
    navigate(-1);
  };

  const formContent = (
    <>
      <div className="sm:px-6 px-[12px]">
        <div className="pt-6 pb-4 border-b border-primary-green/20 w-full">
          <h2 className="md:text-2xl text-xl font-semibold text-gray-800">
            {isEditMode ? "Edit IMS" : "Inventory Management System Registration"}
          </h2>
        </div>
      </div>
      <div className="field_Container sm:px-6 px-4" style={{ marginTop: 0 }}>
        <form onSubmit={handleSubmit} className="form_responsive">
          <div className="group-fields">
            <div className="field-container">
              <h6 className="field-txt !text-lg">Name</h6>
              <input
                type="text"
                id="imsName"
                name="imsName"
                placeholder="IMS name"
                className="formField"
                value={formValues?.imsName ?? ""}
                onChange={(e) => setFormValues({ ...formValues, imsName: e.target.value })}
                required
              />
            </div>
              <div className="field-container">
                <h6 className="field-txt !text-lg">Email</h6>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  className="formField"
                  value={formValues?.email ?? ""}
                  onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                />
              </div>
          </div>
              <div className="group-fields">
                <div className="field-container">
                  <h6 className="field-txt !text-lg">Password</h6>
                  <div className="formField relative">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      name="password"
                      placeholder="Password"
                      className=""
                      value={formValues?.password}
                      onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
                    />
                    <button
                      type="button"
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer w-max bg-transparent text-black shadow-none"
                      onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    >
                      {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
                <div className="field-container">
                  <h6 className="field-txt !text-lg">Phone Number</h6>
                  <PhoneInput
                    value={formValues?.phoneNumber}
                    name="phoneNumber"
                    placeholder="Enter phone number"
                    className="formField"
                    required
                    onChange={(value) => setFormValues({ ...formValues, phoneNumber: value })}
                    style={{
                      display: "flex",
                      background: "white",
                      borderRadius: "10px",
                      padding: "0px 10px",
                      border: "1px solid #444444",
                      overflow: "hidden",
                    }}
                  />
                </div>
              </div>
              <div className="group-fields">
                <div className="field-container">
                  <h6 className="field-txt !text-lg">License Key</h6>
                  <input
                    type="text"
                    id="license_key"
                    name="license_key"
                    placeholder="License Key"
                    className="formField"
                    value={formValues?.license_key}
                    onChange={(e) => setFormValues({ ...formValues, license_key: e.target.value })}
                    required
                  />
                </div>
                <div className="field-container">
                  <h6 className="field-txt !text-lg">DB Backup URL</h6>
                  <input
                    type="text"
                    value={formValues?.db_backup_url}
                    name="db_backup_url"
                    placeholder="DB Backup URL"
                    className="formField"
                    required
                    onChange={(e) => setFormValues({ ...formValues, db_backup_url: e.target.value })}
                  />
                </div>
              </div>
          <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">City</h6>
                        <input
                          type="text"
                          id="City"
                          name="City"
                          placeholder="City"
                          className="formField"
                          value={formValues?.city}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              city: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">State</h6>
                        <input
                          type="text"
                          id="state"
                          name="state"
                          placeholder="State"
                          className="formField"
                          value={formValues?.state}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              state: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="group-fields">
                    <div className="field-container">
                        <h6 className="field-txt !text-lg">Address</h6>
                        <input
                          type="text"
                          id="address"
                          name="address"
                          placeholder="address"
                          className="formField"
                          value={formValues?.address}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              address: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      
                      
                    </div>
          <div className="pb-6 sm:pt-0 pt-[20px] flex gap-3 flex-wrap">
            {isEditMode && (
              <button
                type="button"
                onClick={onCancel}
                className="w-max px-5 py-2.5 rounded-full border border-primary-green text-primary-green font-medium hover:bg-primary-green/5 transition-colors"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="!font-quicksand primary-button"
              disabled={loading}
              style={{ fontFamily: "", fontWeight: 500 }}
            >
              {loading ? "Loading..." : isEditMode ? "Update" : "Register IMS"}
            </button>
          </div>
        </form>
      </div>
    </>
  );

  if (isEditMode) {
    return (
      <div className="relative bg-white rounded-2xl shadow-xl border border-primary-green/20 overflow-hidden">
        {onCancel && (
          <button
            type="button"
            className="w-max absolute top-4 right-4 z-10 text-gray-600 hover:text-gray-800 bg-primary-green/10 p-1.5 rounded-full cursor-pointer"
            onClick={onCancel}
            aria-label="Close"
          >
            <IoMdClose className="text-xl" />
          </button>
        )}
        {formContent}
      </div>
    );
  }

  return (
    <AuthWrapper>
      <div className="fixed inset-0 z-[100] flex justify-center">
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setShowModal?.(false)}
        />
        <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
          <div className="relative z-[200] w-full max-w-4xl my-auto">
            <div className="bg-[#FCFBF7] rounded-3xl shadow-xl border border-primary-green/10">
              <button
                className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer hover:text-gray-700 text-2xl z-10"
                onClick={() => setShowModal?.(false)}
              >
                <IoMdClose className="text-black" />
              </button>
              {formContent}
            </div>
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default RegisterIms;
